const backendPort = "https://algorithmbackend.elcexercises.org/";

export default backendPort;
